import dayjs from 'dayjs';
import {fromJson, json, JsonMappers} from '../core/data-source/json.mapper';
import {AddressRecord} from './address.record';
import {CustomerRecord} from './customer.record';
import {DictionaryRecord} from './dictionary.record';
import {LocationAvailabilityRecord} from './location-availability.record';
import {NotificationModeRecord, NotificationModeRecordNames} from './notification-mode.record';
import {VehicleRequirementRecord} from './vehicle-requirement.record';

export class CustomerLocationRecord {
    @json()
    id: number;

    @json()
    name: string;

    @json({
        mapper: JsonMappers.InstanceOf(() => AddressRecord)
    })
    address: AddressRecord;

    @json() contactName: string;

    @json() phone: string;

    @json() secondaryPhoneNumber: string;

    @json({
        mapper: JsonMappers.ArrayOf(() => NotificationModeRecord),
        value: [
            {
                id: null,
                name: NotificationModeRecordNames.SMS,
                enable: true // по умолчанию вкл.
            },
            {
                id: null,
                name: NotificationModeRecordNames.EMAIL,
                enable: true // по умолчанию вкл.
            }
        ]
    })
    notificationModeRecords: NotificationModeRecord[];

    @json() email: string;

    @json({
        jsonName: 'time_of_operations',
        value: [],
        mapper: JsonMappers.ArrayOf(() => LocationAvailabilityRecord)
    })
    timeOfOperations: LocationAvailabilityRecord[];

    // @field({
    //     name: 'time_of_operations',
    //     parser: 'parseTimeOfOperations',
    //     model: LocationAvailabilityModel
    // })
    // timeOfOperations: LocationAvailabilityModel[];

    @json({value: false})
    locationIsVerified: boolean;

    @json() lastVerificationByUserName: string;

    @json({
        jsonName: 'lastVerificationWhen',
        mapper: {
            from: (data: any, record: any): string => {
                if (record.lastVerificationWhen) {
                    // const format: string = momentUtil.getMomentFormat('fullDateTime').format;
                    const format: string = 'DD/MM/YYYY HH:mm';
                    return dayjs.utc(Number(data)).format(format);
                }
            }
        }
    })
    lastVerificationWhenFormatted: string;

    @json() lastVerificationWhen: string;

    @json({value: 0})
    customerIndex: number;

    @json() referenceNumber: string;

    @json() website: string;

    @json(JsonMappers.InstanceOf(() => CustomerRecord))
    customer: CustomerRecord;

    @json({
        jsonName: 'prefer_drivers',
        mapper: JsonMappers.ArrayOf(() => DictionaryRecord)
    })
    preferDrivers: DictionaryRecord[];

    @json(JsonMappers.ArrayOf(() => VehicleRequirementRecord))
    types: VehicleRequirementRecord[];

    @json(JsonMappers.InstanceOf(() => DictionaryRecord))
    landmarkType: DictionaryRecord;

    @json({
        value: ''
    })
    comments: string;

    @json({
        mapper: {
            from: (data: any): number => (data !== void 0 ? data * 1000 : void 0),
            to: (data: any, record: CustomerLocationRecord): number =>
                record.allowAdditionalTimePerVisit ? (data !== void 0 ? data / 1000 : data) : null
        }
    })
    additionalTimePerVisit: number;

    @json({
        mapper: {
            from: (data: any): number => (data !== void 0 ? data * 1000 : void 0),
            to: (data: any, record: CustomerLocationRecord): number =>
                record.allowFixedOperationDuration ? (data !== void 0 ? data / 1000 : data) : null
        }
    })
    fixedOperationDuration: number;

    @json({
        mapper: {
            to: (data: null, record: CustomerLocationRecord) => (record.allowDropDurationPerUnit ? data : null)
        }
    })
    dropDurationPerUnit: number;

    @json({
        mapper: {
            to: (data: null, record: CustomerLocationRecord) => (record.allowPickupDurationPerUnit ? data : null)
        }
    })
    pickupDurationPerUnit: number;

    @json()
    timeZone: any;

    @json({
        skip: true,
        jsonName: 'additionalTimePerVisit',
        mapper: {
            from: (value: number) => value !== undefined
        }
    })
    allowAdditionalTimePerVisit: any;

    @json({
        skip: true,
        jsonName: 'fixedOperationDuration',
        mapper: {
            from: (value: number) => value !== undefined
        }
    })
    allowFixedOperationDuration: any;

    @json({
        skip: true,
        jsonName: 'dropDurationPerUnit',
        mapper: {
            from: (value: number) => value !== undefined
        }
    })
    allowDropDurationPerUnit: any;

    @json({
        skip: true,
        jsonName: 'pickupDurationPerUnit',
        mapper: {
            from: (value: number) => value !== undefined
        }
    })
    allowPickupDurationPerUnit: any;
}
